import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const NotesFieldWrapper = styled.div`
  margin: 0;
  padding: 28px 24px 40px 24px;

  ${media.md`
    border: none;
    margin: 0;
    padding: 32px 0 32px 0;
  `}
`;

export const TitleText = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  width: 100%;
`;
